/** This enumeration indicates whether to return results in ascending or descending order */
export enum SortEnum {
    Asc = 'ASC',
    Desc = 'DESC'
}
